(function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    new TG_ProductQuickvew();
    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
        new themegoal.components.LoadingBar();
    }

    let windowWidth = window.innerWidth;
    let headerSection = document.getElementById('shopify-section-header');
    let announcementBarSection = document.getElementById('shopify-section-announcement-bar');
    let pageHeader = document.getElementById('PageHeader');

    window.addEventListener('resize', function () {
        let newWidth = window.innerWidth;

        if (newWidth === windowWidth) {
        return;
        }

        windowWidth = newWidth;

        document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

        if (headerSection) {
            document.documentElement.style.setProperty('--tg-header-height', headerSection.clientHeight + 'px');
            document.documentElement.style.setProperty('--tg-header-logo-width', document.querySelector('.Header__LogoWrapper').offsetWidth + 'px');
        }

        if (announcementBarSection) {
            document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.clientHeight + 'px');
        }

        if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.clientHeight + 'px');
        }

    });


    new TG_SearchDrawer();

})();